import gsap from "gsap";

// Le gsap.matchMedia restano attive anche dopo aver lasciato la pagina e si ricreano a ogni
// cambio di breakpoint, sulla pagina successiva: le annulliamo quando il componente viene smontato.
// Va chiamato nel setup; la funzione restituita si usa poi in onMounted al posto di gsap.matchMedia().
export const useGsapMatchMedia = () => {
    const contexts: gsap.MatchMedia[] = [];

    onUnmounted(() => contexts.forEach((context) => context.revert()));

    return () => {
        const mm = gsap.matchMedia();
        contexts.push(mm);
        return mm;
    };
};
